import { useTranslation } from 'react-i18next';
import { date, object, string, number } from 'yup';

import { yupFile } from '@utils/yup';

import { FormValues } from './type';
import { PolicyTypes } from '@models/policyType';

export const useFormValues = () => {
  const values: FormValues = {
    insurerId: '',
    benefitTemplateId: '',
    companyId: '',
    insuranceType: '',
    policyType: '',
    activationDate: '',
    activationPeriod: '',
    adminFeeAmount: '',
    note: '',
    proof: undefined,
    descriptionHtml: '',
  };
  return values;
};

export const useFormSchema = () => {
  const { t } = useTranslation();
  return object({
    insurerId: number().required(t('validation:required')),
    benefitTemplateId: number().required(t('validation:required')),
    companyId: number()
      .when('policyType', {
        is: (policyType: PolicyTypes) => policyType === PolicyTypes.Commercial,
        then: (schema) => schema.required(t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
    insuranceType: string().required(t('validation:required')),
    policyType: string().required(t('validation:required')),
    activationDate: date().required(t('validation:required')),
    activationPeriod: string().required(t('validation:required')),
    adminFeeAmount: number().required(t('validation:required')),
    note: string().required(t('validation:required')),
    proof: yupFile(),
    descriptionHtml: string().required(t('validation:required')),
  });
};
